import { useState } from "react";
import { useEffect } from "react"
import * as helper from '../global/helper';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { getCancellationSheet } from "../api/teeTimeAPI";
import swal from 'sweetalert2';
import EditTeeTimeCancellation from "./editTeeTimeCancellation";

const CancellationSheet = (props) => {

    const [selectedFromDate,                setSelectedFromDate]         = useState(moment().toDate());
    const [selectedToDate,                  setSelectedToDate]           = useState(moment().toDate());
    const [isInit,                          setIsInit]                   = useState(true);
    const [cancellationSheet,               setCancellationSheet]        = useState([]);
    const [cancellationTable,               setCancellationTable]        = useState(null);
    const [cancellationDetails,             setCancellationDetails]      = useState(null);

    // useEffect(() => {
    //     props.title('Cancellation Sheet ','tee-cancel-sheet')
    //     $('#txtFromDate').datepicker({
    //         format: 'dd-mm-yyyy',
    //         minDate: new Date(),
    //     });
    //     $('#txtFromDate').on('change', function (event) {
    //         setSelectedFromDate(event.target.value);
    //     });
    //     $('#txtToDate').datepicker({
    //         format: 'dd-mm-yyyy',
    //         minDate: new Date(),
    //     });
    //     $('#txtToDate').on('change', function (event) {
    //         setSelectedToDate(event.target.value)
    //     });
    // },[])

    useEffect(() => {
        props.title('Cancellation Sheet', 'tee-cancel-sheet');
    
        $('#txtFromDate').datepicker({
            format: 'dd-mm-yyyy',
            autoclose: true,
            todayHighlight: true,
            endDate: selectedToDate ? moment(selectedToDate, 'DD-MM-YYYY').toDate() : null
        }).on('changeDate', function (e) {
            const selected = e.date;
            const formatted = moment(selected).format('DD-MM-YYYY');
            setSelectedFromDate(formatted);
    
            $('#txtToDate').datepicker('setStartDate', selected);
        });
    
        $('#txtToDate').datepicker({
            format: 'dd-mm-yyyy',
            autoclose: true,
            todayHighlight: true,
            startDate: selectedFromDate ? moment(selectedFromDate, 'DD-MM-YYYY').toDate() : null
        }).on('changeDate', function (e) {
            const selected = e.date;
            const formatted = moment(selected).format('DD-MM-YYYY');
            setSelectedToDate(formatted);
    
            $('#txtFromDate').datepicker('setEndDate', selected);
        });
    }, []);
    

    useEffect(() => {       
        if (!isInit) {
            fillTable();
        }
    }, [cancellationSheet]);

    useEffect(() => {
        if(selectedFromDate && selectedToDate){
            fetchCancellationSheet(moment(selectedFromDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), moment(selectedToDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),)
        }
    },[selectedFromDate, selectedToDate])

    const fetchCancellationSheet = async(fdate, tDate) => {
        try {
            swal.fire({
                titleText: 'Loading',
                text: 'Please Wait...',
                showConfirmButton: false,
                onOpen: () => {
                    swal.showLoading();
                }
            });
            const response = await getCancellationSheet(fdate, tDate);
            // const response = []
            isInit ? setIsInit(false) : $('#tblCancelSheet').KTDatatable().destroy(); 
            setCancellationSheet(response.CancelSheet)
            swal.close();
        } catch (err) {
            Swal.fire({
                icon      : 'error',
                titleText : err.message
            })  
        }
    }


    function exportSheet(type) {
        cancellationTable.update({
            headers: true,
            formats: ["xlsx", "csv"],
            filename: `${moment().format("DD-MM-YYYY")} - Tee Cancellation Sheet` // pass in a new set of properties
        });

        if (type == 'xlsx') {
            $('.button-default.xlsx').click();
        } else {
            $('.button-default.csv').click();
        }
        $('.tableexport-caption').addClass('hidden');
    }


    function fillTable() {

        Swal.close();

        $.each(cancellationSheet, function (index, element) {

            if (element.Status != null) {
                element["Status"] = '<div class="badge badge-danger"><span>' + element["Status"] + '</span></div>';
            }

        });

        Config.Core.InitPopover();

        const dataTable = $('#tblCancelSheet').KTDatatable({
            
            data: {
                saveState: false,
                source: cancellationSheet,
            },
            layout: {
                scroll: false,
                footer: false,
            },
            sortable: false,
            pagination: false,
            search: {
                input: $('#generalSearch'),
            },
            columns: [
                {
                    field: 'CancelDate',
                    title: "Cancel Dt",
                    width: 50,
                    template: function (row) {
                        return moment(row.CancelDate).format('DD-MM-YYYY');
                    }
                },
                {
                    field: 'BookDate',
                    title: "Game Dt ",
                    width: 50,
                    template: function (row) {
                        return moment(row.BookDate).format('DD-MM-YYYY');
                    }
                },
                { field: "Slot", title: "Slot", width: 60 },
 
                { field: "Hole", title: "Holes", width: 40, },
                {
                    field: 'Player1',
                    title: 'Player 1',
                    template: function (row) {
                        if (row?.Player1) {
                            return `<span class='kt-badge kt-badge--${row.UserType1 == "User" ? 'success' : (row.UserType1 == "Guest" || row.UserType1 == "UsersGuest") ? 'warning' : 'danger'} kt-badge--dot'></span>&nbsp;&nbsp;${row.Player1}`
                        }else {
                            return '';
                        }
                    }
                },
                {
                    field: 'Player2',
                    title: 'Player 2',
                    template: function (row) {
                        if (row?.Player2) {
                            return `<span class='kt-badge kt-badge--${row.UserType2 == "User" ? 'success' : (row.UserType2 == "Guest" || row.UserType2 == "UsersGuest") ? 'warning' : 'danger'} kt-badge--dot'></span>&nbsp;&nbsp;${row.Player2}`
                        }else {
                            return '';
                        }
                    }
                },
                {
                    field: 'Player3',
                    title: 'Player 3',
                    template: function (row) {
                        if (row?.Player3) {
                            return `<span class='kt-badge kt-badge--${row.UserType3 == "User" ? 'success' : (row.UserType3 == "Guest" || row.UserType3 == "UsersGuest") ? 'warning' : 'danger'} kt-badge--dot'></span>&nbsp;&nbsp;${row.Player3}`
                        }else {
                            return '';
                        }
                    }
                },
                {
                    field: 'Player4',
                    title: 'Player 4',
                    template: function (row) {
                        if (row?.Player4) {
                            return `<span class='kt-badge kt-badge--${row.UserType4 == "User" ? 'success' : (row.UserType4 == "Guest" || row.UserType4 == "UsersGuest") ? 'warning' : 'danger'} kt-badge--dot'></span>&nbsp;&nbsp;${row.Player4}`
                        }else {
                            return '';
                        }
                    }
                },
                {
                    field: 'Comment',
                    title: 'User Comment',
                    width: 60,
                    template: function (row) {
                        if (!!row.Comment) {
                            return '';
                        } else {
                            return row.Comment;
                        }
                    }
                },
                {
                    field: 'RefundComment',
                    title: 'Refund Comment',
                    width: 60,
                    template: function (row) {
                        if (row.RefundComment == null) {
                            return '';
                        } else {
                            return row.RefundComment;
                        }
                    }
                },
                {
                    field: 'TrackingID',
                    title: 'Tracking ID',
                    width: 120,
                    template: function (row) {
                        return `<div style="word-break: break-word;">${row.TrackingID || ''}</div>`;
                    }
                },
                {
                    field: 'PaymentMode',
                    title: 'Pay. Mode',
                    width: 90,
                },
                {
                    field: 'PGAmount',
                    title: 'Bill Amt'
                },
                {
                    field: 'RefundAmount',
                    title: 'Refund Amt'
                },
                {
                    field: 'RefundRefNo',
                    title: 'Refund Ref No'
                },
                {
                    field: 'Status',
                    title: 'Status',
                    template: function (row) {
                        var text = row.Status;
                        if (row.Status === null) {
                            return "<div class='badge badge-success'><span>Available</span></div>";
                        } else {
                            return text;
                        }
                    }
                },
                {
                    field: 'RefundStatus',
                    title: 'Refund Status',
                    template: function (row) {
                        if (row.RefundStatus === 'Pending') {
                            return "<div class='badge badge-warning'><span>Pending</span></div>";
                        } else {
                            return "<div class='badge badge-success'><span>success</span></div>";
                        }
                    },
                    width: 70,
                },
                {
                    field: '',
                    title: '',
                    width: 50,
                    class: "clickable",
                    template: function (row) {
                        return showEditButton(row)
                    }
                }
            ],
            rows: {
                autoHide: false,
            }
            
        });
        
        Config.Core.InitPopover();
        Config.Core.GrabAndScroll('.kt-datatable__table');
        function showEditButton(row) {
            var optString = '';
            optString += '<center>'
            optString += `<button type="button"  class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs btn-edit"><i class="flaticon2-edit"></i></button>`
            optString += '</center>'
            return optString;
        }

        // export to excel
        const CancellationTable = $('.kt-datatable__table').tableExport({
            formats: ["xlsx", "csv"],
            headers: true,
            filename: `${moment().format("DD-MM-YYYY")} - Tee Cancellation Sheet`,
        });
        setCancellationTable(CancellationTable);
        $('.tableexport-caption').addClass('hidden');
        dataTable.on('click', '.btn-edit', function (ss) {
            const index = $(ss.currentTarget).parents('tr').index();
            if (dataTable.dataSet && dataTable.dataSet.length > 0 && dataTable.dataSet[index]) {
                setCancellationDetails(dataTable.dataSet[index]);
            }
        });
        

    }
    return(
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content"  >
                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet">
                        <div className="kt-portlet__body padding-t20 padding-b0">
                            <div id="ControlHolder" className="kt-form kt-form--label-right padding-10" role="form">
                                <div className="row">
                                    <label className="col-form-label col-sm-1 text-right">From Date</label>
                                    <div className="form-group col-sm-2">
                                        <div className="input-group date">
                                            <input 
                                                id="txtFromDate" 
                                                name="txtFromDate" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Select date" 
                                                defaultValue={moment(selectedFromDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} 
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">
                                                    <i className="la la-calendar-check-o"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <label className="col-form-label col-sm-1 text-right">To Date</label>
                                    <div className="form-group  col-sm-2">
                                        <div className="input-group date">
                                            <input 
                                                id="txtToDate" 
                                                name="txtToDate" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Select date" 
                                                defaultValue={moment(selectedToDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} 
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">
                                                    <i className="la la-calendar-check-o"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div  className="col-sm-1">
                                        {/* <button id="btnSearch" type="button" className="btn btn-label-brand d-inline-block"><i className="la la-search"></i></button> */}
                                    </div>
                                    <div className="form-group col-sm-2">
                                        <div className="input-group">
                                            <div className="kt-input-icon kt-input-icon--left">
                                                <input 
                                                    type="text" 
                                                    className="form-control clientSearch" 
                                                    placeholder="Search Tee Time..." 
                                                    id="generalSearch" 
                                                />
                                                <span className="kt-input-icon__icon kt-input-icon__icon--left"><span><i className="la la-search"></i></span></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-1">
                                        <div className="dropdown">
                                            <button className="btn btn-label-brand dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Export
                                            </button>
                                            <div className="dropdown-menu " aria-labelledby="dropdownMenuButton" x-placement="bottom-start" style={{position: 'absolute', willChange: 'transform', top: '0px', left: '0px', transform: 'translate3d(0px, 38px, 0px)'}}>
                                                <button 
                                                    id="btn-export-excel" 
                                                    type="button" 
                                                    className="dropdown-item"
                                                    onClick={() => exportSheet('xlsx')}

                                                > Excel 
                                                </button>
                                                <button 
                                                    id="btn-export-csv" 
                                                    type="button" 
                                                    className="dropdown-item"
                                                    onClick={() => exportSheet('csv')}
                                                >  Csv </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="tblCancelSheet" className="table table-bordered table-hover custom-datatable"></div>
                        </div>
                    </div>
                </div>
            </div>
            {!!cancellationDetails && (
                <EditTeeTimeCancellation
                    cancellationDetails={cancellationDetails}
                    onDismissModal={setCancellationDetails}
                    refetchData={() => fetchCancellationSheet(moment(selectedFromDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), moment(selectedToDate, 'DD-MM-YYYY').format('YYYY-MM-DD'))}
                />
            )}
        </>
    )
}

export default CancellationSheet